import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "condition-rule-divider"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "condition-rule-divider__line" }, null, -1)
const _hoisted_4 = { class: "condition-rule-divider__select min-max-width-80" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "condition-rule-divider__line" }, null, -1)
const _hoisted_6 = { class: "d-flex flex-row align-items-center" }
const _hoisted_7 = { class: "min-max-width-30 margin-left-3" }
const _hoisted_8 = ["data-depth", "onClick"]
const _hoisted_9 = { class: "margin-left-3 width-100" }
const _hoisted_10 = ["onMouseenter"]
const _hoisted_11 = ["value", "id", "data-id"]
const _hoisted_12 = ["id", "onClick", "onBlur", "onPasteCapture"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "preview form-control",
  style: {"display":"none"}
}, null, -1)
const _hoisted_14 = { class: "min-max-width-160 margin-left-3" }
const _hoisted_15 = { class: "margin-left-3 width-100" }
const _hoisted_16 = ["onMouseenter"]
const _hoisted_17 = ["value", "id", "data-id"]
const _hoisted_18 = ["id", "onClick", "onBlur", "onPasteCapture"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "preview form-control",
  style: {"display":"none"}
}, null, -1)
const _hoisted_20 = { class: "min-max-width-30 margin-left-3" }
const _hoisted_21 = ["data-depth", "onClick"]
const _hoisted_22 = { class: "d-flex margin-left-3" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "d-flex justify-content-between margin-top-10"
}
const _hoisted_26 = { class: "color-red font-size-14 d-flex align-items-center justify-content-center" }

import {
  ref,
  inject,
  nextTick,
  onBeforeMount,
  onBeforeUnmount,
  watch,
  defineAsyncComponent,
  onMounted,
  computed,
  onUnmounted,
} from "vue";
import { ElSelect, ElOption } from "element-plus";
import {
  getCaretPosition,
  setCaretPosition,
  saveCaretPosition,
  ensureCaretRestored,
  copyContainerContent,
  handlePastedHtml,
  isOurSpanHtml,
  handleBackspaceZWSP,
} from "@/core/json-forms/components/service";
import {
  addOutput as commonAddOutput,
  addMetaoutput as commonAddMetaoutput,
  addUserVariable as commonAddUserVariable,
  addSystemVariable as commonAddSystemVariable,
  addFunction as commonAddFunction,
} from "@/core/json-forms/components/spanInjection";
import i18n from "@/core/i18n/i18n";
import { getPreferenceValue } from "@/core/preferences/preferences";
import {
  clearActiveFunctionInjectionTarget,
  getActiveFunctionInjectionTarget,
  getFunctionInjectionTarget,
  hasOpenFunctionSelector,
  setActiveFunctionInjectionTarget,
} from "@/core/json-forms/components/functionInjectionTarget";
import {
  getTooltipForMetaoutput,
  getTooltipForUdv,
} from "../application/useTooltipForTags";
import { registerFlowInputFlusher } from "../application/conditionInputFlushRegistry";
import {
  normalizeMetaoutputReference,
  normalizeOutputReference,
  PREFER_ORIG_ID_OUTPUT_REFERENCES_KEY,
} from "../utils/outputReferenceUtils";

interface Condition {
  rule: string;
  firstInput: string;
  secondInput: string;
  leftParen: boolean;
  rightParen: boolean;
  condition: string;
}

type ConditionInputSide = "first-input" | "second-input";


export default /*#__PURE__*/_defineComponent({
  __name: 'Condition',
  props: {
    conditions: {},
    inRouter: { type: Boolean },
    stepIndex: {},
    outputList: {},
    idSuffix: {},
    isActive: { type: Boolean },
    userDefinedVariables: {},
    systemVariables: {},
    expressions: {},
    metaoutputList: {}
  },
  emits: [
  "close",
  "change-functions-visible",
  "on-change",
  "add-default",
  "focused",
  "changes-happened",
],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "b0c8fc64": (parenColor1.value),
  "b0c8fc62": (parenColor2.value),
  "b0c8fc60": (parenColor3.value),
  "b0c8fc5e": (parenColor4.value),
  "b0c8fc5c": (parenColor5.value),
  "b0c8fc5a": (parenColor6.value)
}))

const FunctionSelector = defineAsyncComponent(
  () => import("@/core/json-forms/components/FunctionSelector.vue")
);

const { t } = i18n.global;
const preferOrigIdOutputReferences = inject(
  PREFER_ORIG_ID_OUTPUT_REFERENCES_KEY,
  true
);

const props = __props;

const emit = __emit;

const hoveredField = ref<string>("");

const recentlyCopied = ref<string>("");

const focusIx = ref(-1);

const focusId = ref("");

const visible = ref(false);

const inputChangeFlag = ref(false);

const isFirstRun = ref(true);

const oldPath = ref("");

const idCount = ref(0);

const selectedOutputId = ref();

const selectedMetaoutputId = ref();

const parentheses = ref("");

const hydrating = ref(false);

const parenthesesColors = ref(getPreferenceValue("accordionColors"));
const parenColor1 = computed(() => parenthesesColors.value[0]);
const parenColor2 = computed(() => parenthesesColors.value[1]);
const parenColor3 = computed(() => parenthesesColors.value[2]);
const parenColor4 = computed(() => parenthesesColors.value[3]);
const parenColor5 = computed(() => parenthesesColors.value[4]);
const parenColor6 = computed(() => parenthesesColors.value[5]);
let keyupDebounceTimer: ReturnType<typeof setTimeout> | null = null;

function flushPendingInput() {
  if (keyupDebounceTimer) {
    clearTimeout(keyupDebounceTimer);
    keyupDebounceTimer = null;
  }
  convertToInputString();
}

const unregisterInputFlusher = registerFlowInputFlusher(flushPendingInput);

const error = computed(() => {
  // eslint-disable-next-line vue/no-side-effects-in-computed-properties
  parentheses.value = "";
  conditions.value.forEach((condition) => {
    if (condition.leftParen) {
      parentheses.value += "(";
    }
    if (condition.rightParen) {
      parentheses.value += ")";
    }
  });
  return !isBalancedParentheses(parentheses.value);
});

const parenDepths = computed(() => {
  const out = conditions.value.map(() => ({ left: 0, right: 0 }));
  let depth = 0;

  for (let i = 0; i < conditions.value.length; i++) {
    const c = conditions.value[i];

    if (c.leftParen) {
      depth += 1;
      out[i].left = depth;
    }

    if (c.rightParen) {
      out[i].right = Math.max(depth, 0);
      depth = Math.max(depth - 1, 0);
    }
  }
  return out;
});

function isBalancedParentheses(input: string): boolean {
  const stack = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const char of input) {
    if (char === "(") {
      stack.push(char);
    } else if (char === ")") {
      if (stack.pop() !== "(") {
        return false;
      }
    }
  }
  return stack.length === 0;
}

const computedId = computed(() => {
  if (focusId.value) {
    return `${focusId.value}-div-${props.idSuffix}`;
  }
  return "";
});

const conditionInjectionTarget = {
  isAvailable: () =>
    Boolean(computedId.value && document.getElementById(computedId.value)),
  closeSelector: () => {
    visible.value = false;
  },
  addOutput: (params, first, isNotFirstRender = true) =>
    addOutput(params, first, isNotFirstRender),
  addMetaoutput: (params, first, isNotFirstRender = true) =>
    addMetaoutput(params, first, isNotFirstRender),
  addUserVariable: (params, first) => addUserVariable(params, first),
  addSystemVariable: (params, first) => addSystemVariable(params, first),
  addFunction: (params, first) => addFunction(params, first),
};

function getConditionInjectionTarget(first, isNotFirstRender = true) {
  return getFunctionInjectionTarget(
    conditionInjectionTarget,
    first,
    isNotFirstRender
  );
}

const conditions = ref([
  {
    leftParen: false,
    rightParen: false,
    firstInput: "[]",
    secondInput: "[]",
    condition: "",
    rule: null,
  },
] as Condition[]);

const rules = ref(["AND", "OR", "NOT"]);

const operators = ref([
  {
    key: "EQUAL_TO",
    label: "Condition.EqualTo",
    showRight: true,
    showLeft: true,
  },
  {
    key: "NOT_EQUAL_TO",
    label: "Condition.NotEqualTo",
    showRight: true,
    showLeft: true,
  },
  {
    key: "CONTAINS",
    label: "Condition.Contains",
    showRight: true,
    showLeft: true,
  },
  {
    key: "DOES_NOT_CONTAIN",
    label: "Condition.DoesNotContain",
    showRight: true,
    showLeft: true,
  },
  {
    key: "STARTS_WITH",
    label: "Condition.StartsWith",
    showRight: true,
    showLeft: true,
  },
  {
    key: "DOES_NOT_START_WITH",
    label: "Condition.DoesNotStartWith",
    showRight: true,
    showLeft: true,
  },
  {
    key: "IS_GREATER_THAN",
    label: "Condition.IsGreaterThan",
    showRight: true,
    showLeft: true,
  },
  {
    key: "IS_LESS_THAN",
    label: "Condition.IsLessThan",
    showRight: true,
    showLeft: true,
  },
  {
    key: "IS_ODD",
    label: "Condition.IsOdd",
    showRight: false,
    showLeft: true,
  },
  {
    key: "IS_EVEN",
    label: "Condition.IsEven",
    showRight: false,
    showLeft: true,
  },
  {
    key: "IS_NULL",
    label: "Condition.IsNull",
    showRight: false,
    showLeft: true,
  },
  {
    key: "IS_NOT_NULL",
    label: "Condition.IsNotNull",
    showRight: false,
    showLeft: true,
  },
  {
    key: "IS_EMPTY",
    label: "Condition.IsEmpty",
    showRight: false,
    showLeft: true,
  },
  {
    key: "IS_NOT_EMPTY",
    label: "Condition.IsNotEmpty",
    showRight: false,
    showLeft: true,
  },
  {
    key: "STEP_FAILED",
    label: "Condition.DidStepFail",
    showRight: false,
    showLeft: false,
  },
  {
    key: "STEP_SUCCEEDED",
    label: "Condition.DidStepSucceed",
    showRight: false,
    showLeft: false,
  },
  {
    key: "STEP_FAILED_WITH_CODE",
    label: "Condition.DidStepFailWithCode",
    showRight: true,
    showLeft: true,
  },
]);

function closeConditions() {
  clearActiveFunctionInjectionTarget(conditionInjectionTarget);
  visible.value = false;
  focusIx.value = -1;
  focusId.value = "";
}

function addCondition(index: number) {
  conditions.value.splice(index + 1, 0, {
    leftParen: false,
    rightParen: false,
    firstInput: "[]",
    secondInput: "[]",
    condition: "",
    rule: index + 1 > 0 ? rules.value[0] : null,
  });
}

function removeCondition(index) {
  if (conditions.value.length === 1) {
    const singleCondition = conditions?.value[0];
    singleCondition.leftParen = false;
    singleCondition.rightParen = false;
    singleCondition.firstInput = "[]";
    singleCondition.secondInput = "[]";
    singleCondition.condition = "";
    singleCondition.rule = null;

    const firstInputDiv = document.getElementById(
      `first-input-0-div-${props.idSuffix}`
    );
    const secondInputDiv = document.getElementById(
      `second-input-0-div-${props.idSuffix}`
    );
    if (firstInputDiv) firstInputDiv.innerHTML = "";
    if (secondInputDiv) secondInputDiv.innerHTML = "";
  } else {
    conditions.value.splice(index, 1);
    if (conditions.value.length > 0) {
      conditions.value[0].rule = null;
    } else {
      emit("close");
    }
  }
}
const storedRange = ref<Range | null>(null);

function onBlur(e: FocusEvent, index: number, side: ConditionInputSide) {
  syncConditionInput(index, side, e);
  if (keyupDebounceTimer) {
    clearTimeout(keyupDebounceTimer);
    keyupDebounceTimer = null;
  }
  const isActiveTarget =
    getActiveFunctionInjectionTarget() === conditionInjectionTarget;
  if (
    visible.value ||
    hydrating.value ||
    (isActiveTarget && hasOpenFunctionSelector())
  ) {
    /* If the panel (e.g. FunctionSelector) is still open,
    only save the caret position—don’t clear focusIx/focusId. */
    storedRange.value = saveCaretPosition(e.target as Node);
    return;
  }
  // Panel is closed, so now clear our focus tracking:
  storedRange.value = saveCaretPosition(e.target as Node);
  focusIx.value = -1;
  focusId.value = "";
}

function setFocusIx(index, id) {
  setActiveFunctionInjectionTarget(conditionInjectionTarget);
  focusIx.value = index;
  focusId.value = `${id}-${index}`;
  visible.value = visible.value || !hasOpenFunctionSelector();
  emit("focused", index);
}

const previousId = ref(null);

function onKeyDown(event) {
  const div = document.getElementById(computedId.value);
  if (event.key === "Enter") {
    if (div.childNodes.length === 0) {
      addBrElement();
    } else if (div.childNodes.length === 1) {
      const node = div.childNodes[0];
      const isBr =
        node.nodeType === Node.ELEMENT_NODE &&
        node?.tagName?.toLowerCase() === "br";
      if (!isBr) {
        addBrElement();
      }
    }
    event.preventDefault();
    insertNewLine(div);
  } else if (event.key === "Backspace") {
    if (
      div.childNodes.length === 1 &&
      div.childNodes[0] instanceof HTMLBRElement
    ) {
      div.removeChild(div.childNodes[0]);
    }
    if (handleBackspaceZWSP(div, computedId.value)) {
      event.preventDefault();
    }
  }
}

function addBrElement() {
  const br = document.createElement("br");
  document.getElementById(computedId.value).appendChild(br);
}

function insertNewLine(div) {
  const br = document.createElement("br");
  const selection = window.getSelection();
  const range = selection.getRangeAt(0);
  range.deleteContents();
  range.insertNode(br);
  range.setStartAfter(div.childNodes[div.childNodes.length - 1]);
  range.collapse(true);
  selection.removeAllRanges();
  selection.addRange(range);
}
watch(
  () => computedId.value,
  (newValue) => {
    inputChangeFlag.value = false;
    if (previousId.value) {
      const oldEl = document.getElementById(previousId.value);
      if (oldEl) {
        oldEl.removeEventListener("paste", pasteEvent);
      }
    }

    const newEl = document.getElementById(newValue);
    if (newEl) {
      newEl.addEventListener("paste", pasteEvent);
    }
    previousId.value = newValue;
  }
);
function addOutput(params, first, isNotFirstRender = true) {
  const target = getConditionInjectionTarget(first, isNotFirstRender);
  if (target !== conditionInjectionTarget) {
    if (target.addOutput) {
      target.addOutput(params, first, isNotFirstRender);
    }
    return;
  }

  if (params.stepIndex > -1) {
    const span: HTMLSpanElement = commonAddOutput(
      params,
      props.outputList,
      idCount.value,
      isNotFirstRender
    );
    idCount.value++;
    addItemToInput(span, first);
  }
}

function addMetaoutput(params, first, isNotFirstRender = true) {
  const target = getConditionInjectionTarget(first, isNotFirstRender);
  if (target !== conditionInjectionTarget) {
    if (target.addMetaoutput) {
      target.addMetaoutput(params, first, isNotFirstRender);
    }
    return;
  }

  if (params.stepIndex > -1) {
    const span: HTMLSpanElement = commonAddMetaoutput(
      {
        name: params.name,
        path: params.path,
        stepIndex: params.stepIndex,
        stepNumber: params.stepNumber,
        origId: params.origId,
      },
      props.metaoutputList,
      idCount.value,
      isNotFirstRender
    );
    idCount.value++;
    addItemToInput(span, first);
  }
}

function addUserVariable(params, first) {
  const target = getConditionInjectionTarget(first);
  if (target !== conditionInjectionTarget) {
    if (target.addUserVariable) {
      target.addUserVariable(params, first);
    }
    return;
  }

  const span: HTMLSpanElement = commonAddUserVariable(
    {
      name: params.name,
      path: params.path,
      stepIndex: 0,
      tooltip: params.tooltip,
    },
    props.userDefinedVariables,
    idCount.value,
    true
  );
  idCount.value++;
  addItemToInput(span, first);
}
function addSystemVariable(params, first) {
  const target = getConditionInjectionTarget(first);
  if (target !== conditionInjectionTarget) {
    if (target.addSystemVariable) {
      target.addSystemVariable(params, first);
    }
    return;
  }

  const span: HTMLSpanElement = commonAddSystemVariable(
    {
      name: params.name,
      path: params.name,
      stepIndex: 0,
      tooltip: params.tooltip,
    },
    params,
    idCount.value
  );
  idCount.value++;
  addItemToInput(span, first);
}

function addFunction(params, first) {
  const target = getConditionInjectionTarget(first);
  if (target !== conditionInjectionTarget) {
    if (target.addFunction) {
      target.addFunction(params, first);
    }
    return;
  }

  const spans = commonAddFunction(params, idCount.value);

  spans.forEach((span) => {
    addItemToInput(span, first);
  });

  idCount.value += spans.length;
  if (params.hasChild) {
    const mainSpan = spans[0];
    const zwsp = mainSpan.nextSibling;
    if (zwsp && zwsp.nodeType === Node.TEXT_NODE) {
      setCaretPosition(zwsp, computedId.value, 1);
    }
  }
}

function getNextSibling(current?) {
  const elem = document.getElementById(computedId.value);
  const position = getCaretPosition(elem);
  let length = 0;
  let set = false;
  let childIndex = -1;
  elem.childNodes.forEach((child: any, index) => {
    if (child.nodeType === Node.TEXT_NODE) {
      length += child.data.length;
    } else if (child.nodeType === Node.ELEMENT_NODE) {
      length += child.innerText.length;
    }
    if (position <= length && !set && position !== 0) {
      childIndex = index;
      set = true;
    } else if (position === 0) {
      childIndex = -2;
      set = true;
    }
  });
  if (childIndex > -1) {
    return current
      ? {
          item: elem.childNodes.item(childIndex),
          index: childIndex,
        }
      : {
          item: elem.childNodes.item(childIndex + 1),
          index: childIndex + 1,
        };
  }
  if (childIndex === -2) {
    return {
      item: elem.childNodes.item(0),
      index: 0,
    };
  }
  return null;
}

function split(text, index) {
  return [text.slice(0, index), text.slice(index)];
}

function addItemToInput(span: HTMLSpanElement, first) {
  ensureCaretRestored(computedId.value, storedRange.value);
  const zeroWidthSpace = document.createTextNode("\u200B");
  const container = document.getElementById(computedId.value);
  const current: any = getNextSibling(true);
  const nextNode = getNextSibling();
  if (
    current &&
    current.item.nodeType === Node.TEXT_NODE &&
    current.item.data.length > 1 &&
    !first
  ) {
    const [firstText, second] = split(
      current.item.data,
      getCaretPosition(document.getElementById(computedId.value)) -
        getInputLengthToCaretPosition(current.index)
    );
    const firstElem = current.item;
    firstElem.data = firstText;
    document
      .getElementById(computedId.value)
      .replaceChild(firstElem, current.item);
    if (nextNode.item) {
      document
        .getElementById(computedId.value)
        .insertBefore(span, nextNode.item);
    } else {
      document.getElementById(computedId.value).appendChild(span);
    }

    if (nextNode.item) {
      document
        .getElementById(computedId.value)
        .insertBefore(document.createTextNode(second), nextNode.item);
    } else {
      document
        .getElementById(computedId.value)
        .appendChild(document.createTextNode(second));
    }
  } else {
    addToDocument(
      span,
      zeroWidthSpace,
      nextNode ? nextNode.item : undefined,
      first
    );
  }
  let trailingNode: Text;
  if (span.nextSibling && span.nextSibling.nodeType === Node.TEXT_NODE) {
    trailingNode = span.nextSibling as Text;
    if (
      trailingNode.textContent === "" ||
      trailingNode.textContent === "\u200B"
    ) {
      trailingNode.textContent = "\u200B";
      (trailingNode as any).dataset = { caretAnchor: "true" };
    }
  } else {
    trailingNode = document.createTextNode("\u200B");
    (trailingNode as any).dataset = { caretAnchor: "true" };
    container.insertBefore(trailingNode, span.nextSibling);
  }
  organizeNodes();
  setCaretPosition(span, computedId.value);
}

function clearFocusCompletely() {
  clearActiveFunctionInjectionTarget(conditionInjectionTarget);
  visible.value = false;
  focusIx.value = -1;
  focusId.value = "";
  const sel = window.getSelection?.();
  if (sel && typeof sel.removeAllRanges === "function") {
    sel.removeAllRanges();
  }

  const ae = document.activeElement as HTMLElement | null;
  if (ae && typeof ae.blur === "function") {
    ae.blur();
  }
}

function addToDocument(span, zero, next, first) {
  if (next && !first) {
    document.getElementById(computedId.value).insertBefore(span, next);
    document.getElementById(computedId.value).insertBefore(zero, span);
  } else {
    document.getElementById(computedId.value).appendChild(span);
    document.getElementById(computedId.value).appendChild(zero);
  }
}

function organizeNodes(event?: Event) {
  // Debounce keyup events (user is actively typing)
  if (
    event &&
    typeof event === "object" &&
    (event as KeyboardEvent).type === "keyup"
  ) {
    if (keyupDebounceTimer) {
      clearTimeout(keyupDebounceTimer);
    }
    keyupDebounceTimer = setTimeout(() => {
      keyupDebounceTimer = null;
      doOrganizeNodes(false);
    }, 150);
    return;
  }

  // All other cases run immediately
  if (keyupDebounceTimer) {
    clearTimeout(keyupDebounceTimer);
    keyupDebounceTimer = null;
  }
  doOrganizeNodes(true);
}

async function doOrganizeNodes(syncModel: boolean) {
  try {
    await nextTick();
    document
      .getElementById(computedId.value)
      .childNodes.forEach((child, index) => {
        const nextChild = document
          .getElementById(computedId.value)
          .childNodes.item(index + 1);
        if (nextChild) {
          if (
            nextChild.nodeType === child.nodeType &&
            child.nodeType === Node.TEXT_NODE
          ) {
            const childText = child.textContent.trim();
            const nextText = nextChild.textContent.trim();
            const specialCharsRegex = /^[\u200B"']$/;
            if (
              specialCharsRegex.test(childText) ||
              specialCharsRegex.test(nextText)
            ) {
              return;
            }
            if (
              nextChild.textContent === "\u200B" ||
              child.textContent === "\u200B"
            ) {
              document
                .getElementById(computedId.value)
                .removeChild(
                  child.textContent !== "\u200B" ? nextChild : child
                );
            } else {
              child.textContent += nextChild.textContent;
              child.textContent = child.textContent.replace("\u200B", "");
              document.getElementById(computedId.value).removeChild(nextChild);
            }
          }
        }
      });
  } catch (e) {
    console.log(e, "organize");
  }
  if (syncModel) {
    convertToInputString();
  }
}

function convertToInputString() {
  if (focusId.value.startsWith("first-input")) {
    syncConditionInput(focusIx.value, "first-input");
  } else if (focusId.value.startsWith("second-input")) {
    syncConditionInput(focusIx.value, "second-input");
  }
}

function syncConditionInput(
  index: number,
  side: ConditionInputSide,
  event?: Event
) {
  try {
    const eventTarget = event?.currentTarget as HTMLElement | null;
    const container =
      eventTarget ||
      document.getElementById(`${side}-${index}-div-${props.idSuffix}`);
    const condition = conditions.value[index];
    if (!container || !condition) {
      return;
    }

    const inputArray = [];
    container.childNodes.forEach((child: any) => {
      if (child instanceof HTMLBRElement) {
        inputArray.push({
          name: Array(1).fill("\n").join(""),
          type: "input",
          function: "",
        });
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        const name = child.getAttribute("name");
        const type = child.getAttribute("type");
        if (name !== null && type !== null) {
          inputArray.push({
            name: child.getAttribute("name"),
            origId: child.getAttribute("origId"),
            type: child.getAttribute("type"),
            function: child.getAttribute("function"),
          });
        }
      } else if (
        child.nodeType === Node.TEXT_NODE &&
        child.textContent !== "" &&
        child.textContent !== "\u200B"
      ) {
        inputArray.push({
          name: child.textContent.replaceAll("\u200B", ""),
          type: "input",
        });
      }
    });
    if (
      inputArray.length > 0 &&
      inputArray[inputArray.length - 1]?.name === "\n"
    ) {
      inputArray.pop();
    }
    if (side === "first-input") {
      condition.firstInput = JSON.stringify(inputArray);
    }
    if (side === "second-input") {
      condition.secondInput = JSON.stringify(inputArray);
    }
  } catch (e) {
    console.log(e, "string");
  }
}

function getInputLengthToCaretPosition(index) {
  let length = 0;
  document
    .getElementById(`${focusId.value}-div-${props.idSuffix}`)
    .childNodes.forEach((node: any, idx) => {
      if (node.nodeType === Node.TEXT_NODE && idx < index) {
        length += node.data.length;
      } else if (node.nodeType === Node.ELEMENT_NODE && idx < index) {
        length += node.innerText.length;
      }
    });
  return length;
}

function addClickEvent() {
  try {
    const conditionElement = document.getElementById(
      `conditions-${props.idSuffix}`
    );
    if (conditionElement) {
      conditionElement.addEventListener("click", (event: any) => {
        const popperElement = document.getElementById(
          `conditions-${props.idSuffix}-popper`
        );
        const isContainsPopper = popperElement
          ? popperElement.contains(event.target)
          : false;

        const focusElement = focusId.value
          ? document.getElementById(`${focusId.value}-div-${props.idSuffix}`)
          : null;
        const isContainsDiv = focusElement
          ? focusElement.contains(event.target)
          : false;

        if (isContainsPopper) {
          visible.value = true;
        } else if (isContainsDiv) {
          setActiveFunctionInjectionTarget(conditionInjectionTarget);
          visible.value = visible.value || !hasOpenFunctionSelector();
        } else if (visible.value && conditionElement.contains(event.target)) {
          visible.value = true;
        } else {
          visible.value = false;
        }
      });
    }
  } catch (e) {
    visible.value = false;
  }
}

function addText(item, divId) {
  const text = document.createTextNode(item.name);
  document.getElementById(divId).appendChild(text);
}

function pasteEvent(
  e: ClipboardEvent,
  index: number,
  side: ConditionInputSide
) {
  e.stopPropagation();
  e.preventDefault();
  setFocusIx(index, side);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line no-nested-ternary
  const clipboardData = e.clipboardData || window.clipboardData;
  const pastedData = clipboardData.getData("text/plain");
  const html = clipboardData.getData("text/html");
  const range = document.getSelection().getRangeAt(0);
  if (isOurSpanHtml(html)) {
    handlePastedHtml(
      html,
      document.getElementById(computedId.value),
      range,
      props.outputList as any[],
      props.metaoutputList as any[],
      {
        preferOrigId: preferOrigIdOutputReferences,
      }
    );
    syncConditionInput(index, side);
    setTimeout(() => {
      organizeNodes(e);
    }, 100);
    return;
  }
  range.deleteContents();
  const textNode = document.createTextNode(pastedData);
  range.insertNode(textNode);
  range.selectNodeContents(textNode);
  range.collapse(false);
  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
  syncConditionInput(index, side);
  // e.stopPropagation();
  e.preventDefault();
}

async function addToDiv(data, id, index) {
  focusId.value = id;
  focusIx.value = index;
  try {
    const elements = JSON.parse(data);
    let newlineCount = false;
    elements.forEach((item) => {
      if (item.type === "input") {
        if (item.name === "\n") {
          newlineCount = true;
          addBrElement();
        } else {
          addText(item, computedId.value);
        }
      } else if (item.type === "output") {
        const normalizedOutput = normalizeOutputReference({
          name: item.name,
          origId: item.origId,
          outputList: props.outputList,
          preferOrigId: preferOrigIdOutputReferences,
        });
        const arr = normalizedOutput.name.split("/#");
        const outputStepId =
          typeof normalizedOutput.index === "number"
            ? normalizedOutput.index
            : -1;
        selectedOutputId.value = outputStepId;
        addOutput(
          {
            name:
              outputStepId > -1 && arr.length >= 2
                ? `/${outputStepId}/#${arr[1]}`
                : normalizedOutput.name,
            path: outputStepId > -1 && arr.length >= 2 ? `/#${arr[1]}` : "",
            stepIndex: outputStepId,
            stepNumber:
              outputStepId > -1 ? normalizedOutput.stepNumber : undefined,
            origId: normalizedOutput.origId ?? item.origId,
          },
          true,
          false
        );
      } else if (item.type === "user-defined-variable") {
        const arr = item.name.split("/#");
        const value = arr.length >= 2 ? arr[1] : "";
        let tooltip = getTooltipForUdv(value, props.userDefinedVariables);
        tooltip =
          typeof tooltip === "object" ? JSON.stringify(tooltip) : tooltip;
        addUserVariable(
          {
            name: arr.length >= 2 ? `/#${arr[1]}` : "",
            path: arr.length >= 2 ? `/#${arr[1]}` : "",
            tooltip,
          },
          true
        );
      } else if (item.type === "system-variable") {
        const systemVariables = {
          name: item.name,
          tooltip: props.systemVariables[item.name] || "",
        };
        addSystemVariable(systemVariables, true);
      } else if (item.type === "metaoutput") {
        const normalizedMetaoutput = normalizeMetaoutputReference({
          name: item.name,
          origId: item.origId,
          metaoutputList: props.metaoutputList,
          preferOrigId: preferOrigIdOutputReferences,
        });
        const arr = normalizedMetaoutput.name.split("/#");
        const metaoutputStepId =
          typeof normalizedMetaoutput.index === "number"
            ? normalizedMetaoutput.index
            : -1;
        const metaPath =
          arr.length >= 2 ? arr[1].split("@#").slice(1).join("@#") : "";
        selectedMetaoutputId.value = metaoutputStepId;
        const tooltip = getTooltipForMetaoutput(
          metaPath,
          metaoutputStepId,
          props.metaoutputList
        );
        addMetaoutput(
          {
            name:
              metaoutputStepId > -1 && metaPath
                ? `/${metaoutputStepId}/#${metaPath}`
                : normalizedMetaoutput.name,
            path: metaPath ? `/#${metaPath}` : "",
            stepIndex: metaoutputStepId,
            stepNumber:
              metaoutputStepId > -1
                ? normalizedMetaoutput.stepNumber
                : undefined,
            origId: normalizedMetaoutput.origId ?? item.origId,
            tooltip,
          },
          true,
          false
        );
      } else {
        const matchedExpression = props.expressions.find(
          (expression) => expression.name === item.name
        );
        const tooltip = matchedExpression?.description;
        const params = { ...item, tooltip };
        addFunction(params, true);
      }
    });
    if (newlineCount) {
      addBrElement();
    }
  } catch (e) {
    console.log(e);
  }
}

function copyConditionContent(
  index: number,
  side: "first-input" | "second-input"
) {
  const divId = `${side}-${index}-div-${props.idSuffix}`;
  copyContainerContent(divId)
    .then(() => {
      recentlyCopied.value = divId;
      setTimeout(() => {
        if (recentlyCopied.value === divId) {
          recentlyCopied.value = "";
        }
      }, 2000);
    })
    .catch((err) => {
      console.error("Copy failed", err);
    });
}

watch(
  () => conditions.value,
  () => {
    if (!error.value) {
      conditions.value.forEach((item) => {
        const first = isValueValid(item.firstInput)
          ? JSON.parse(item.firstInput)
          : item.firstInput;
        item.firstInput = processItemValue(first);
        const second = isValueValid(item.secondInput)
          ? JSON.parse(item.secondInput)
          : item.secondInput;
        item.secondInput = processItemValue(second);
      });
      emit("on-change", conditions.value);
      if (isFirstRun.value) {
        isFirstRun.value = false;
      } else {
        emit("changes-happened");
      }
    }
  },
  { deep: true }
);

function isValueValid(value) {
  try {
    JSON.parse(value);
    return true;
  } catch (e) {
    return false;
  }
}
function processItemValue(itemValue) {
  const valid = isValueValid(itemValue);
  try {
    const processedValue = itemValue.map((element) => {
      if (
        element.type === "user-defined-variable" &&
        !element.name.startsWith("/userDefinedVariables")
      ) {
        element.name = `/userDefinedVariables${element.name}`;
      }
      return element;
    });
    return valid ? processedValue : JSON.stringify(processedValue);
  } catch (e) {
    return itemValue;
  }
}

watch(
  () => visible.value,
  () => {
    /* When the popup actually closes, we’ll clear focus data in onBlur().
  But because clicks inside FunctionSelector may briefly toggle visible,
  we don’t reset focusIx/focusId here to avoid losing the caret.
  focusIx.value = -1;
  focusId.value = "";
  if (!visible.value) {
    focusIx.value = -1;
    focusId.value = "";
  } */
    if (inputChangeFlag?.value !== true) {
      emit("change-functions-visible", visible.value);
    }
  }
);

onBeforeUnmount(flushPendingInput);

onUnmounted(() => {
  unregisterInputFlusher();
  clearActiveFunctionInjectionTarget(conditionInjectionTarget);
  closeConditions();
  if (keyupDebounceTimer) {
    clearTimeout(keyupDebounceTimer);
    keyupDebounceTimer = null;
  }
});
const computedIsActive = computed(() => props.isActive);

watch(computedIsActive, (newVal) => {
  if (newVal === false) {
    const activeTarget = getActiveFunctionInjectionTarget();
    if (
      visible.value &&
      activeTarget &&
      activeTarget !== conditionInjectionTarget &&
      hasOpenFunctionSelector()
    ) {
      return;
    }
    visible.value = false;
    inputChangeFlag.value = true;
  }
});
onMounted(async () => {
  addClickEvent();
  hydrating.value = true;
  try {
    for (let index = 0; index < conditions.value.length; index += 1) {
      const condition = conditions.value[index];
      await addToDiv(condition.firstInput, `first-input-${index}`, index);
      await addToDiv(condition.secondInput, `second-input-${index}`, index);
    }
  } finally {
    hydrating.value = false;
    await nextTick();
    clearFocusCompletely();
  }
});

onBeforeMount(() => {
  if (props.conditions) {
    conditions.value = props.conditions;
  }
  if (conditions?.value?.length === 0) {
    addCondition(-1);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    id: 'conditions-' + _ctx.idSuffix
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conditions.value, (condition, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: condition }, [
        (index !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(ElSelect), {
                  modelValue: condition.rule,
                  "onUpdate:modelValue": ($event: any) => ((condition.rule) = $event),
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rules.value, (rule) => {
                      return (_openBlock(), _createBlock(_unref(ElOption), {
                        key: rule,
                        value: rule,
                        label: rule
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"])
              ]),
              _hoisted_5
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: _normalizeClass(["cond-paren open btn", 
              condition.leftParen ? 'btn-oneTeg-inline' : 'btn-oneTeg-outline'
            ]),
              style: {"height":"32px","padding":"0 8px !important"},
              "data-depth": parenDepths.value[index]?.left || 0,
              onClick: ($event: any) => (condition.leftParen = !condition.leftParen)
            }, " ( ", 10, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("div", {
              class: "input-div",
              onMouseenter: ($event: any) => (hoveredField.value = `first-input-${index}`),
              onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (hoveredField.value = ''))
            }, [
              _createElementVNode("input", {
                value: condition.firstInput,
                style: {"display":"none"},
                id: 'first-input-' + index + '-input-' + _ctx.idSuffix,
                "data-id": 'first-input-' + index + '-data-' + _ctx.idSuffix,
                class: "input form-control"
              }, null, 8, _hoisted_11),
              (hoveredField.value === `first-input-${index}`)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: 
                recentlyCopied.value === `first-input-${index}-div-${_ctx.idSuffix}`
                  ? 'check'
                  : 'copy'
              ,
                    class: "copy-icon",
                    onClick: ($event: any) => (copyConditionContent(index, 'first-input'))
                  }, null, 8, ["icon", "onClick"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                id: 'first-input-' + index + '-div-' + _ctx.idSuffix,
                class: "form-control root-div",
                contenteditable: "true",
                onClick: ($event: any) => (setFocusIx(index, 'first-input')),
                onBlur: ($event: any) => (onBlur($event, index, 'first-input')),
                onKeydown: onKeyDown,
                onPasteCapture: _withModifiers(
                (e) => pasteEvent(e, index, 'first-input')
              , ["prevent"]),
                onKeyup: organizeNodes,
                spellcheck: "false"
              }, null, 40, _hoisted_12),
              _hoisted_13
            ], 40, _hoisted_10), [
              [_vShow, 
              condition.condition
                ? operators.value.find((op) => op.key === condition.condition)
                    .showLeft
                : true
            ]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_unref(ElSelect), {
              modelValue: condition.condition,
              "onUpdate:modelValue": ($event: any) => ((condition.condition) = $event),
              size: "small"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operators.value, (operator) => {
                  return (_openBlock(), _createBlock(_unref(ElOption), {
                    key: operator.key,
                    value: operator.key,
                    label: _unref(t)(operator.label)
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("div", {
              class: "input-div",
              onMouseenter: ($event: any) => (hoveredField.value = `second-input-${index}`),
              onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hoveredField.value = ''))
            }, [
              _createElementVNode("input", {
                value: condition.secondInput,
                style: {"display":"none"},
                id: 'second-input-' + index + '-input-' + _ctx.idSuffix,
                "data-id": 'second-input-' + index + '-data-' + _ctx.idSuffix,
                class: "input form-control"
              }, null, 8, _hoisted_17),
              (hoveredField.value === `second-input-${index}`)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: 
                recentlyCopied.value === `second-input-${index}-div-${_ctx.idSuffix}`
                  ? 'check'
                  : 'copy'
              ,
                    class: "copy-icon",
                    onClick: ($event: any) => (copyConditionContent(index, 'second-input'))
                  }, null, 8, ["icon", "onClick"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                id: 'second-input-' + index + '-div-' + _ctx.idSuffix,
                class: "form-control root-div",
                contenteditable: "true",
                onClick: ($event: any) => (setFocusIx(index, 'second-input')),
                onKeyup: organizeNodes,
                onBlur: ($event: any) => (onBlur($event, index, 'second-input')),
                onKeydown: onKeyDown,
                onPasteCapture: _withModifiers(
                (e) => pasteEvent(e, index, 'second-input')
              , ["prevent"]),
                spellcheck: "false"
              }, null, 40, _hoisted_18),
              _hoisted_19
            ], 40, _hoisted_16), [
              [_vShow, 
              condition.condition
                ? operators.value.find((op) => op.key === condition.condition)
                    .showRight
                : true
            ]
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              class: _normalizeClass(["cond-paren close btn", 
              condition.rightParen ? 'btn-oneTeg-inline' : 'btn-oneTeg-outline'
            ]),
              style: {"height":"32px","padding":"0 8px !important"},
              "data-depth": parenDepths.value[index]?.right || 0,
              onClick: ($event: any) => (condition.rightParen = !condition.rightParen)
            }, " ) ", 10, _hoisted_21)
          ]),
          _createElementVNode("div", _hoisted_22, [
            (conditions.value.length > 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-link-icon",
                  onClick: ($event: any) => (removeCondition(index))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "eraser",
                    size: "sm",
                    class: "fa-fw"
                  })
                ], 8, _hoisted_23))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn btn-oneTeg float-right",
              onClick: ($event: any) => (addCondition(index))
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: "plus",
                size: "sm",
                class: "fa-fw"
              })
            ], 8, _hoisted_24)
          ])
        ])
      ], 64))
    }), 128)),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, _toDisplayString(error.value ? _unref(t)("Common.ParenthesesError") : ""), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(FunctionSelector), {
      "output-list": _ctx.outputList,
      "old-path": oldPath.value,
      "id-prefix": 'conditions-' + _ctx.idSuffix,
      visible: visible.value,
      mode: "input",
      "show-other-inputs": true,
      showMeta: true,
      "metaoutput-list": _ctx.metaoutputList,
      onAddOutput: addOutput,
      onAddUserVariable: addUserVariable,
      "user-defined-variables": _ctx.userDefinedVariables,
      "system-variables": _ctx.systemVariables,
      expressions: _ctx.expressions,
      onAddSystemVariable: addSystemVariable,
      onAddFunction: addFunction,
      onAddMetaoutput: addMetaoutput
    }, null, 8, ["output-list", "old-path", "id-prefix", "visible", "metaoutput-list", "user-defined-variables", "system-variables", "expressions"])
  ], 8, _hoisted_1))
}
}

})